import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import Breadcrumbs from "components/Common/Breadcrumb";

import {
  getAllLabs,
  approveUnapproveLab,
  getApprovedLabs,
  getcyclelist,
} from "store/registration-admin/actions";

import "assets/scss/table.scss";

class Membershipstatusreport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AllLabs: [],
      LabModal: false,
      selectedParticipants: [],
      modalTitle: "",
      drilldownModal: false, // second modal for sector labs
      sectorDrilldown: null, // { sector, labs }
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
  }

  componentDidMount() {
    const { user_id } = this.state;
    if (!user_id) return;
    const { onGetPendingLabs } = this.props;
    if (onGetPendingLabs) onGetPendingLabs(user_id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.AllLabs !== this.props.AllLabs) {
      this.setState({ AllLabs: this.props.AllLabs || [] });
    }
  }

  // Build pivot: rows = lab types, columns = provinces
  buildPivot() {
    const { AllLabs } = this.state;
    const pivot = {};
    const provincesSet = new Set();
    const labTypesSet = new Set();

    AllLabs.forEach(lab => {
      const labType = (lab.type || "Unknown").trim();
      const province = (lab.province || "Unknown").trim();
      labTypesSet.add(labType);
      provincesSet.add(province);

      if (!pivot[labType]) pivot[labType] = {};
      if (!pivot[labType][province]) pivot[labType][province] = [];
      pivot[labType][province].push(lab);
    });

    const provinceOrder = [
  "Punjab",
  "Federal",
  "Sindh",
  "Balochistan",
  "KPK",
  "AJK",
  // "Lab",
];

const provinces = Array.from(provincesSet).sort((a, b) => {
  const indexA = provinceOrder.indexOf(a);
  const indexB = provinceOrder.indexOf(b);

  if (indexA === -1) return 999;
  if (indexB === -1) return -1;

  return indexA - indexB;
});
    const labTypes = Array.from(labTypesSet).sort();

    const rows = labTypes.map(labType => {
      const row = { key: labType, lab_type: labType };
      let rowTotal = 0;
      provinces.forEach(p => {
        const count = pivot[labType]?.[p]?.length || 0;
        row[`province_${p}`] = count;
        row[`_labs_${p}`] = pivot[labType]?.[p] || [];
        rowTotal += count;
      });
      row["total"] = rowTotal;
      return row;
    });

    // Total row
    const totalRow = { key: "__total__", lab_type: "Total", total: 0 };
    provinces.forEach(p => {
      const sum = labTypes.reduce(
        (acc, lt) => acc + (pivot[lt]?.[p]?.length || 0),
        0
      );
      totalRow[`province_${p}`] = sum;
      totalRow[`_labs_${p}`] = [];
      totalRow["total"] += sum;
    });
    rows.push(totalRow);

    return { rows, provinces };
  }

  openModal = (labs, title) => {
    if (!labs || labs.length === 0) return;
    this.setState({
      selectedParticipants: labs,
      LabModal: true,
      modalTitle: title,
      sectorDrilldown: null,
      drilldownModal: false,
    });
  };

  closeModal = () => {
    this.setState({
      LabModal: false,
      sectorDrilldown: null,
      drilldownModal: false,
    });
  };

  openDrilldown = (sector, labs) => {
    this.setState({
      sectorDrilldown: { sector, labs },
      drilldownModal: true,
    });
  };

  closeDrilldown = () => {
    this.setState({ drilldownModal: false, sectorDrilldown: null });
  };

  render() {
    const { rows, provinces } = this.buildPivot();

    // ── Main pivot columns ────────────────────────────────────────────────────
    const columns = [
      {
        dataField: "lab_type",
        text: "Lab Type",
        sort: true,
        headerStyle: {
          textAlign: "center",
          width: "150px",
          whiteSpace: "nowrap",
        },
        style: { textAlign: "left", fontWeight: "500" },
        formatter: (cell, row) =>
          row.key === "__total__" ? (
            <strong>{cell}</strong>
          ) : (
            <span>{cell}</span>
          ),
      },
      ...provinces.map(p => ({
        dataField: `province_${p}`,
        text: p,
        sort: true,
        headerStyle: { textAlign: "center", whiteSpace: "nowrap" },
        style: { textAlign: "center" },
        formatter: (cell, row) => {
          if (row.key === "__total__") {
            return <strong style={{ color: "#856404" }}>{cell || "--"}</strong>;
          }
          if (!cell || cell === 0)
            return <span style={{ color: "#aaa" }}>--</span>;
          return (
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() =>
                this.openModal(row[`_labs_${p}`], `${row.lab_type} — ${p}`)
              }
            >
              {cell}
            </span>
          );
        },
      })),
      {
        dataField: "total",
        text: "Total",
        sort: true,
        headerStyle: {
          textAlign: "center",
          backgroundColor: "#e3f2fd",
          whiteSpace: "nowrap",
        },
        style: {
          textAlign: "center",
          backgroundColor: "#e3f2fd",
          fontWeight: "700",
        },
        formatter: (cell, row) =>
          row.key === "__total__" ? (
            <strong style={{ color: "#856404" }}>{cell}</strong>
          ) : (
            <span>{cell || "--"}</span>
          ),
      },
    ];

    // ── Sector pivot for the first modal ─────────────────────────────────────
    const buildSectorPivot = () => {
      const map = {};
      (this.state.selectedParticipants || []).forEach(lab => {
        const raw = (lab.sector || "").trim();
        const sector =
          raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase() || "Unknown";
        if (!map[sector]) map[sector] = [];
        map[sector].push(lab);
      });
      const sectors = Object.keys(map).sort();
      const dataRow = { key: "counts" };
      let total = 0;
      sectors.forEach(s => {
        dataRow[`sector_${s}`] = map[s].length;
        dataRow[`_labs_${s}`] = map[s];
        total += map[s].length;
      });
      dataRow["sector_total"] = total;
      dataRow["_labs_total"] = this.state.selectedParticipants;
      return { sectors, dataRow };
    };

    const { sectors: modalSectors, dataRow: modalDataRow } = buildSectorPivot();

    const sectorPivotColumns = [
      ...modalSectors.map(s => ({
        dataField: `sector_${s}`,
        text: s,
        sort: false,
        headerStyle: { textAlign: "center", whiteSpace: "nowrap" },
        style: { textAlign: "center" },
        formatter: (cell, row) => {
          if (!cell || cell === 0)
            return <span style={{ color: "#aaa" }}>--</span>;
          return (
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => this.openDrilldown(s, row[`_labs_${s}`])}
            >
              {cell}
            </span>
          );
        },
      })),
      {
        dataField: "sector_total",
        text: "Total",
        sort: false,
        headerStyle: {
          textAlign: "center",
          backgroundColor: "#e3f2fd",
          whiteSpace: "nowrap",
        },
        style: {
          textAlign: "center",
          backgroundColor: "#e3f2fd",
          fontWeight: "700",
        },
        formatter: (cell, row) => (
          <span
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => this.openDrilldown("All", row["_labs_total"])}
          >
            {cell}
          </span>
        ),
      },
    ];

    // ── Drilldown modal columns ───────────────────────────────────────────────
    const drilldownColumns = [
      {
        dataField: "idx",
        text: "#",
        headerStyle: { textAlign: "center", width: "40px" },
        style: { textAlign: "center" },
      },
      {
        dataField: "name",
        text: "Lab Name",
        sort: true,
        headerStyle: { textAlign: "center" },
        style: { textAlign: "left" },
        filter: textFilter({ placeholder: "" }),
        formatter: cell => cell || "—",
      },
      {
        dataField: "city",
        text: "City",
        sort: true,
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        filter: textFilter({ placeholder: "" }),
        formatter: cell => cell || "—",
      },
    ];

    const drilldownData = (this.state.sectorDrilldown?.labs || []).map(
      (lab, idx) => ({
        ...lab,
        idx: idx + 1,
        key: lab.id || idx,
      })
    );

    const pageOptions = {
      sizePerPage: 50,
      totalSize: rows.length,
      custom: true,
    };

    const rowStyle = row => {
      if (row.key === "__total__") {
        return { backgroundColor: "#fff3cd", fontWeight: "700" };
      }
      return {};
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Provisional Division | External QC</title>
          </MetaTags>

          <Container fluid>
            <Breadcrumbs
              maintitle="Provisional Division"
              title="Admin"
              breadcrumbItem="Provisional Division"
            />

            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="key"
                      columns={columns}
                      data={rows}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="key"
                          columns={columns}
                          data={rows}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <BootstrapTable
                                keyField="key"
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                                bootstrap4
                                bordered={false}
                                columns={columns}
                                data={rows}
                                filter={filterFactory()}
                                rowStyle={rowStyle}
                                wrapperClasses="table-responsive"
                                noDataIndication="No data found"
                              />
                              <Row>
                                <Col>
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>

          {/* ── Modal 1: Sector pivot ─────────────────────────────────────── */}
          <Modal
            isOpen={this.state.LabModal}
            toggle={this.closeModal}
            size="lg"
            className={this.props.className}
          >
            <ModalHeader toggle={this.closeModal} tag="h4">
              {this.state.modalTitle}
            </ModalHeader>
            <ModalBody>
              {modalSectors.length === 0 ? (
                <p>No participants found.</p>
              ) : (
                <BootstrapTable
                  keyField="key"
                  data={[modalDataRow]}
                  columns={sectorPivotColumns}
                  bootstrap4
                  bordered={false}
                  wrapperClasses="table-responsive"
                  noDataIndication="No data"
                />
              )}
            </ModalBody>
          </Modal>

          {/* ── Modal 2: Individual labs for selected sector ──────────────── */}
          <Modal
            isOpen={this.state.drilldownModal}
            toggle={this.closeDrilldown}
            size="lg"
            className={this.props.className}
            style={{ zIndex: 1060 }}
          >
            <ModalHeader toggle={this.closeDrilldown} tag="h4">
              {this.state.modalTitle}
              {this.state.sectorDrilldown &&
                this.state.sectorDrilldown.sector !== "All" &&
                ` › ${this.state.sectorDrilldown.sector}`}
              {this.state.sectorDrilldown &&
                this.state.sectorDrilldown.sector === "All" &&
                " › All Sectors"}
            </ModalHeader>
            <ModalBody>
              {drilldownData.length === 0 ? (
                <p>No labs found.</p>
              ) : (
                <BootstrapTable
                  keyField="key"
                  data={drilldownData}
                  columns={drilldownColumns}
                  bootstrap4
                  bordered={false}
                  filter={filterFactory()}
                  wrapperClasses="table-responsive"
                  noDataIndication="No labs found"
                />
              )}
            </ModalBody>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

Membershipstatusreport.propTypes = {
  onGetPendingLabs: PropTypes.func,
  AllLabs: PropTypes.array,
  match: PropTypes.object,
  className: PropTypes.any,
};

const mapStateToProps = state => {
  if (!state.registrationAdmin) {
    return { AllLabs: [] };
  }
  return {
    AllLabs: state.registrationAdmin.AllLabs || [],
  };
};

const mapDispatchToProps = dispatch => ({
  onGetPendingLabs: user_id => dispatch(getAllLabs(user_id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Membershipstatusreport);
